import React from "react";
import "./style.css";


const toggleMenu = () => {

  document.getElementById("navbar").classList.toggle("show");

}

export const Header = ({
  logged_in,
  language
}) => {

  const translations = {
    "en": {
      "courses": "Shop",
      "about": "About",
      "blog": "Blog",
      "contact": "Contact",
      "my_account": "My account",
      "login": "Login",
      "courses_url": "en/tattoo-training",
      "about_url": "en/about",
      "blog_url": "en/blog",
      "contact_url": "en/contact",
      "my_account_url": "en/my-account",
      "login_url": "en/accounts/login"
    },
    "es": {
      "courses": "Tienda",
      "about": "Sobre nosotros",
      "blog": "Blog",
      "contact": "Contacto",
      "my_account": "Mi cuenta",
      "login": "Entrar",
      "courses_url": "es/cursos",
      "about_url": "es/sobre-nosotros",
      "blog_url": "es/blog",
      "contact_url": "es/contacto",
      "my_account_url": "es/mi-cuenta",
      "login_url": "es/accounts/login"
    },
    "pt": {
      "courses": "Loja",
      "about": "Sobre nos",
      "blog": "Blog",
      "contact": "Contato",
      "my_account": "Minha conta",
      "login": "Entrar",
      "courses_url": "pt/cursos",
      "about_url": "pt/sobre-nos",
      "blog_url": "pt/blog",
      "contact_url": "pt/contato",
      "my_account_url": "pt/minha-conta",
      "login_url": "pt/accounts/login"
    },
    "fr": {
      "courses": "Boutique",
      "about": "À propos de nous",
      "blog": "Blog",
      "contact": "Contact",
      "my_account": "Mon compte",
      "login": "Entrer",
      "courses_url": "fr/cours",
      "about_url": "fr/a-propos-de-nous",
      "blog_url": "fr/blog",
      "contact_url": "fr/contact",
      "my_account_url": "fr/mon-compte",
      "login_url": "fr/accounts/login"
    },
    "ru": {
      "courses": "Магазин",
      "about": "О нас",
      "blog": "Блог",
      "contact": "Контакт",
      "my_account": "Мой аккаунт",
      "login": "Войти",
      "courses_url": "ru/tattoo-training",
      "about_url": "en/about",
      "blog_url": "en/blog",
      "contact_url": "en/contact",
      "my_account_url": "en/my-account",
      "login_url": "ru/accounts/login"
    }
  };

  const getTrans = (text) => {

    return translations[language][text];

  }

  return (
    <nav id="main_menu" className="navbar navbar-expand-lg navbar-dark bg-dark">
      <div className="container">
        <a className="navbar-brand" href="/home/">
          <img className="navbar-img" src="https://newcdn.10masters.com/static/logo_white_40px.svg" alt="10 Masters" />
        </a>
        <div onClick={toggleMenu} className="navbar-toggler border-0" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </div>
        <div className="collapse navbar-collapse" id="navbar">
          <ul className="navbar-nav w-100 justify-content-end">
            <li className="nav-item ">
              <a href={`/${getTrans("courses_url")}/`} className="nav-link active" data-ga-event-category="Navbar">
                {getTrans("courses")}
              </a>
            </li>
            <li className="nav-item ">
              <a href={`https://www.10masters.com/${getTrans("about_url")}/`} className="nav-link" data-ga-event-category="Navbar">
              {getTrans("about")}
              </a>
            </li>
            <li className="nav-item ">
              <a href={`https://www.10masters.com/${getTrans("blog_url")}/`} id="blog_menu_button" className="nav-link" data-ga-event-category="Navbar">
              {getTrans("blog")}
              </a>
            </li>
            <li className="nav-item ">
              <a href={`https://www.10masters.com/${getTrans("contact_url")}/`} className="nav-link" data-ga-event-category="Navbar">
              {getTrans("contact")}
              </a>
            </li>
            {
              logged_in ?
                <li className="nav-item">
                  <a id="my_account_li_a" href={`https://www.10masters.com/${getTrans("my_account_url")}/`} className="nav-link ml-lg-5 mr-lg-5" data-ga-event-category="Navbar">
                  {getTrans("my_account")}
                  </a>
                </li>
                :
                <li className="nav-item">
                  <a id="my_account_li_a" href={`https://www.10masters.com/${getTrans("login_url")}/`} className="nav-link ml-lg-5 mr-lg-5" data-ga-event-category="Navbar">
                  {getTrans("login")}
                  </a>
                </li>
            }
          </ul>
        </div>
      </div>


    </nav>
  );
};
